import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import swal from 'sweetalert2';

@Component({
  selector: 'tax-select',
  templateUrl: './tax-select.component.html',
  styleUrls: ['./tax-select.component.scss']
})
export class TaxSelectComponent implements OnInit {


  @Input( ) 
  field : any;

	@Input( )
	elementID: string = 'inputTax';

  @Output( ) 
  onMakeChangeTax = new EventEmitter<any>( );

  selectParams: any = {
    id: 'inputTax',
    isRequired: true,
    change: ( event ) => { },
    options: [ { text: '', value: '' } ]
  };

  editableTax: any = {
  	State: '',
  	percent: ''
  };

  taxesList: any = [];

  taxPopupVisible: boolean = false;
  control: string = '';

  constructor ( private model: ModelService, private global: GlobalService ) { 
  	this.selectParams.id = this.elementID;
  	this.selectParams.change = ( event ) => {
      if ( event.value == 'ADD' ) {
        this.field = '';
        this.addTax( );
      } else {
        this.field = event.value;
				this.onMakeChangeTax.emit( { value: event.value } );
      }
  	};
  }


  ngOnInit ( ) {
  	this._getTaxes( );
  }

  _getTaxes ( ) {

    this.model.getTaxesData( ( data ) => {
    	this.taxesList = data;
      this.selectParams.options = [{ text: '' ,value: '' }, { text: '<strong>+Add New</strong>', value: 'ADD' }];
      data.forEach( tax => {
        this.selectParams.options.push( { text: tax.State+' ('+tax.percent+'%)', value: tax.id } );
      });
    });
  }

  _getCurrentOption ( ) {
  	this.editableTax = {
	  	State: '',
	  	percent: ''
	  };

  	this.taxesList.forEach( ( tax ) => {
  		if ( this.field == tax.id ) this.editableTax = tax;
  	});
  }

  addTax ( ) {
  	this.control = 'ADD';

  	this.editableTax = {
	  	State: '',
	  	percent: ''
	  };

  	this.openTaxPopup( );
  }

  editTax ( ) {
  	this.control = 'EDIT';
  	this._getCurrentOption( );
  	this.openTaxPopup( );
  }

  deleteTax ( ) {

  	this._getCurrentOption( );

    let data = {
      message: 'Are you sure you want to delete "'+this.editableTax.State+' ('+this.editableTax.percent+'%)'+'"?',
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    this.global.confirmMessage( data, ( ) => {

			this.model.deleteTax( this.field )
			.then( ( res ) => { 
        
        if ( res['answer'] == 'success' ) {
          this.successCallback( 'Tax rate has been deleted successfully' );
          this.field = '';
          return true;
        } 

				if ( res['answer'] == 'exists' ) {
					this.global.defaultErrorCallback( this.editableTax.State+' ('+this.editableTax.percent+'%)'+' can not be deleted, because it is used in active projects', false );
          this.field = '';
          return true;
				} 

        this.global.defaultErrorCallback( res['error'], false );
			});
		});
  }


  successCallback ( message ) {
    this.taxPopupVisible = false;
    let data = {
      type: 'success',
      title: 'Success',
      html: message || '',
      showConfirmButton: false
    };
    this._getTaxes( );
    this.global.successMessage( data );
    setTimeout( ( ) => { 
      swal.close( ); 
    }, 2500 );
  }


  openTaxPopup ( ) {
  	this.taxPopupVisible = true;
  }

  closeTaxPopup ( ) {
  	this.taxPopupVisible = false;
  }
	
	submitTaxPopup ( ) {

		if ( this.control == 'EDIT' ) {
			this.model.editTax( this.editableTax )
			.then( ( res ) => { 
				if ( res['answer'] == 'success' ) {
					this.successCallback( 'Tax rate has been edited successfully' );
				} else this.global.defaultErrorCallback( res['answer'], false );
			});
		}

		if ( this.control == 'ADD' ) {

			this.model.addTax( this.editableTax )
			.then( ( res ) => { 
				if ( res['answer'] == 'success' ) {
					this.successCallback( 'New tax rate has been added successfully' );
				} else this.global.defaultErrorCallback( res['answer'], false );
			});
		}

	}

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/projects/tax-select/tax-select.component.ts